import { render } from "./Sheet.vue?vue&type=template&id=0472e525"
import script from "./Sheet.vue?vue&type=script&lang=js"
export * from "./Sheet.vue?vue&type=script&lang=js"
script.render = render

export default script